import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

function triggerOnScroll(trigger) {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: trigger,
            start: 'top 75%'
        },
        defaults: {
            duration: 0.8,
            ease: 'power3.out'
        }

    })
    return tl
}

export default triggerOnScroll